import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";

const Footer = () => {
  const { lang, t } = useI18n();

  return (
    <footer className="bg-brand-black px-6 py-9">
      <div className="container mx-auto max-w-[960px] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <div className="flex items-baseline gap-0">
          <span className="font-display text-2xl text-brand-blue leading-none">A</span>
          <span className="font-display text-2xl text-brand-blue leading-none">-</span>
          <span className="font-display text-2xl text-white leading-none tracking-[0.1em]">WAVE</span>
        </div>
        <div className="text-[11px] font-light tracking-[0.2em] text-white/30 sm:text-right leading-[1.8]">
          <div>{t.footer.location[lang]}</div>
          <div>
            <a href="mailto:hello@awave.pro" className="text-brand-blue no-underline">
              hello@awave.pro
            </a>
          </div>
          <div>
            <Link
              to={lang === "nl" ? "/woordenlijst" : "/en/glossary"}
              className="text-white/50 hover:text-brand-blue transition-colors no-underline"
            >
              {lang === "nl" ? "Woordenlijst" : "Glossary"}
            </Link>
          </div>
          <div className="mt-1.5 text-[9px] tracking-[0.3em] text-white/15">
            TECHNIEK MARKETING EN EVENTS
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
